module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data04-sp-087e8892f2c3a705ee915c2d5087ad9e.png";